import LoadingIcon from "features/ui/Icons/LoadingIcon";

const PageLoadingFallback = () => (
  <div className="p-4">
    <LoadingIcon />
  </div>
);

export default PageLoadingFallback;
